// CART
export const UPDATE_INFO_SCHEDULE = 'update_info_schedule';
